<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="addService.show"
            hide-footer
            hide-header-close
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">เพิ่มบริการเสริม</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <form @submit.prevent="validateService()">
                    <div class="row">
                        <div class="col-lg-12">
                            <UploadImage :imageFile="addService.image"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> ชื่อบริการเสริม
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ชื่อบริการเสริม"
                                    v-model="addService.name"
                                    :class="{ 'is-invalid': submitService && $v.addService.name.$error }"
                                />
                                <div
                                    v-if="submitService && $v.addService.name.required == false"
                                    class="invalid-feedback d-block">กรุณากรอกชื่อบริการเสริม
                                </div> 
                            </div>
                            <div class="form-group">
                                <label>
                                    ค่าบริการ
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ค่าบริการ"
                                    v-model="addService.fee"
                                />
                            </div>
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> เลือกหมวดหมู่
                                </label>
                                <select class="form-control" v-model="addService.categoryId">
                                    <option :value="item.id" v-for="item in category" :key="item.code">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-12 text-center">
                            <b-button variant="outline-primary" class="px-4" @click="closeModal()">
                                ยกเลิก
                            </b-button>
                            <b-button type="submit" variant="primary" class="px-4">
                                <i class="fas fa-circle-notch fa-spin" v-if="addService.isLoad"></i> ยืนยัน
                            </b-button>
                        </div>
                    </div>
                </form>
            </card>
        </b-modal>
    </div>
</template>

<script>
import UploadImage from '@/components/custom/service/UploadImage'
import { createService , updateService } from "@/axios/service.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { required } from "vuelidate/lib/validators";

export default {
    props:{
        category: Array,
        addService: Object
    },
    components:{
        UploadImage
    },
    data(){
        return{
            submitService: false
        }
    },
    validations: {
        addService: {
            name: { required }
        }
    },
    methods:{
        isEdit(){
            return !!this.addService.serviceId
        },
        closeModal(){
            this.addService.show = false
            this.addService.isLoad = false
            this.submitService = false; 
            this.addService.name = ""
            this.addService.fee = null
            this.addService.serviceId = null
            this.addService.image.file = null
            this.addService.image.preview = null
        },
        validateService(){
            this.submitService = true
            this.$v.addService.$touch();
            if (this.$v.addService.$invalid) {
                return false
            }
            this.isEdit() ? this.editService() : this.addServiceDetail()
        },
        addServiceDetail(){
            this.addService.isLoad = true
            createService( this.addService ).then( res => {
                showSuccessModal('เพิ่มบริการเสริมสำเร็จ')
                this.reLoadService()
            }).catch( error => {
                showErrorModal(error)
                this.addService.isLoad = false
            });
        },
        editService(){
            this.addService.isLoad = true
            updateService( this.addService ).then( res => {
                this.addService.serviceId = null
                showSuccessModal('แก้ไขบริการเสริมสำเร็จ')
                this.reLoadService()
            }).catch( error => {
                showErrorModal(error)
                this.addService.isLoad = false
            });
        },
        reLoadService(){
            this.closeModal()
            this.$emit('getApiServiceDetails')
        }
    }
}
</script>